/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import PropTypes from 'prop-types';

// Component imports
import { Layout } from 'antd';

// Constant declarations
const { Content } = Layout;

const EmptyLayout = props => {
  return (
    <Layout className="layout-empty">
      <Content>
        {props.children}
      </Content>
    </Layout>
  );
};

EmptyLayout.propTypes = {
  children: PropTypes.node
};

export default EmptyLayout;
